/* global axios */
import ApiClient from '../ApiClient';

class SocialMonitoringInsightsAPI extends ApiClient {
  constructor() {
    super('social_monitoring/insights', {
      accountScoped: true,
      apiVersion: 'v2',
    });
  }

  political({ profileId, days, platform, refresh } = {}) {
    return axios.get(`${this.url}/political`, {
      params: { profileId, days, platform, refresh },
    });
  }

  topics({ profileId, days, platform } = {}) {
    return axios.get(`${this.url}/topics`, {
      params: { profileId, days, platform },
    });
  }

  publicReaction({ profileId, days, platform } = {}) {
    return axios.get(`${this.url}/public_reaction`, {
      params: { profileId, days, platform },
    });
  }

  publicReactionAnalysis({ profileId, days, platform } = {}) {
    return axios.get(`${this.url}/public_reaction_analysis`, {
      params: { profileId, days, platform },
    });
  }

  clusters({ profileId, days, platform, refresh } = {}) {
    return axios.get(`${this.url}/clusters`, {
      params: { profileId, days, platform, refresh },
    });
  }

  narratives({ profileId, days, platform, refresh } = {}) {
    return axios.get(`${this.url}/narratives`, {
      params: { profileId, days, platform, refresh },
    });
  }

  contentSuggestions({ profileId, days, platform, refresh } = {}) {
    return axios.get(`${this.url}/content_suggestions`, {
      params: { profileId, days, platform, refresh },
    });
  }

  responseLibrary({ profileId, days, platform, refresh } = {}) {
    return axios.get(`${this.url}/response_library`, {
      params: { profileId, days, platform, refresh },
    });
  }

  copilotLatest({ profileId, days, platform } = {}) {
    return axios.get(`${this.url}/copilot/latest`, {
      params: { profileId, days, platform },
    });
  }

  copilotRun({ profileId, days, platform } = {}) {
    return axios.post(`${this.url}/copilot/run`, { profileId, days, platform });
  }
}

export default new SocialMonitoringInsightsAPI();
